import { render, staticRenderFns } from "./ModuleListingContainer.vue?vue&type=template&id=03bf1fb6"
import script from "./ModuleListingContainer.vue?vue&type=script&lang=js"
export * from "./ModuleListingContainer.vue?vue&type=script&lang=js"
import style0 from "./ModuleListingContainer.vue?vue&type=style&index=0&id=03bf1fb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports